import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=70dd7401&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=70dd7401&prod&scoped=true&lang=scss"
import style1 from "./InvoiceDetails.vue?vue&type=style&index=1&id=70dd7401&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd7401",
  null
  
)

export default component.exports